import type { CollectionAdapted } from "~/common/interfaces/entities/collection.interface";

export const getCollectionDefault = (): CollectionAdapted => ({
	id: 0,
	name: "",
	createdAt: new Date().toLocaleString(),
	updatedAt: new Date().toLocaleString(),
	translations: []
});
